import {
    searchCompleted,
    getSearchResultSetFromEntitySet,
    getSearchResultItemsFromResultSet,
} from 'owa-timestream-3s-search';
import { orchestrator } from 'satcheljs';
import { assetSearchCompleted, SearchResultItem } from 'owa-timestream-asset-search';
import type Message from 'owa-service/lib/contract/Message';

orchestrator(searchCompleted, async actionMessage => {
    const { searchRequest, searchResponse } = actionMessage;

    const assetSearchRequest = {
        queryString: searchRequest.EntityRequests[0].Query.QueryString,
        filters: null, // searchCompleted doesn't need to know what the filters were, but we can pull them from the searchRequest if need-be
    };

    if (!searchResponse) {
        assetSearchCompleted(undefined, actionMessage.error, assetSearchRequest);
        return;
    }
    const entitySearchType = searchResponse?.EntitySets[0]?.Type;
    if (!entitySearchType || (entitySearchType !== 'Message' && entitySearchType !== 'Messages')) {
        // ignore 3S requests not for mail items
        return;
    }

    searchResponse.EntitySets.forEach(entitySet => {
        const resultSet = getSearchResultSetFromEntitySet(entitySet);

        const assetSearchResponse = {
            assetType: 'mailItem',
            results: [] as SearchResultItem[],
            searchTerms: searchResponse.SearchTerms,
        };

        // Do not proceed if we did not get any results back
        if (resultSet?.Results && resultSet.Results.length !== 0) {
            const itemList = getSearchResultItemsFromResultSet(
                resultSet,
                entitySet.Type,
                searchRequest
            );

            const searchResults = itemList.map(item => {
                const messageItem = item as Message;
                return {
                    type: 'mailItem',
                    id: messageItem.ItemId?.Id || '',
                    immutableId: messageItem.SerializedImmutableId || '',
                    data: messageItem,
                    matchingTerms: [searchRequest.EntityRequests[0].Query.QueryString],
                };
            });
            assetSearchResponse.results = searchResults;
        }

        // fire search completed with the search results
        assetSearchCompleted(assetSearchResponse, '', assetSearchRequest);
    });
});
